<template>
  <select v-model="selectedValue" v-on:change="emitValue">  
    <option v-for="l in list" :key="l.Dept_ID" v-bind:value="l.Dept_ID">{{l.Description}}</option>
  </select>
</template>

<script>
export default {
  name: 'DepartmentSelector',
  computed:{list : function(){return this.departments}},
  data () { return {selectedValue: undefined}},
  props: ['value', 'departments'],

  created: function(){
    this.selectedValue = this.value;
  },
  methods: {
    emitValue: function(){
      this.$emit('input', this.selectedValue)
    }
  },
  watch:{
    value: function(){
      this.selectedValue = this.value;
    },
    // selectedValue: function(){
      
    // }
  }
}
</script>
